import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/settings')({
  component: Outlet,
});
